import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {NotificationService} from "../../services/NotificationService";
import {AboutService} from "../../services/AboutService";

export class AboutCtrl {
  version:string;
  databaseVersion:string;
  licenseSummary:string;
  newLicense:string;
  public static $inject = ['$scope', '$q', 'AboutService', 'ApplicationSettingService','NotificationService'];

  constructor(public $scope:any,
              public $q:ng.IQService,
              public aboutService:AboutService,
              public applicationSettingService:ApplicationSettingService,
              public notifyService:NotificationService) {
    $scope.vm = this;
    this.$q.all([this.aboutService.getAppVersion(), this.aboutService.getDatabaseVersion(), this.aboutService.getLicenseSummary()]).then((datas)=>{
      this.version = datas[0];
      this.databaseVersion = datas[1];
      this.licenseSummary = datas[2];
    }).catch((exc)=>{
      this.notifyService.notifyError("Got error in getting version:"+exc)
    })
  }
  newLicenseKey():void{
    if(this.newLicense != null && this.newLicense.length > 0){
      this.applicationSettingService.updateLicense(this.newLicense).then(()=>{
        this.aboutService.getLicenseSummary().then((data)=>{
          this.notifyService.notify("License key updated successfully.");
          this.licenseSummary = data;
        });
      }).catch((exc)=>{
        this.notifyService.notifyError("Problem updating license key:"+exc);
      });
    }
  }
}
